module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3ec293692bbf3e8eb82f1e191c782ca4.png";